import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { endpointUrls } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttorneyManagementService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  getAttorney(status): Observable<any> {
    const param = '?includeInactive=' + status;
    const executionEnvData = this.authService.getBackendURLAndExecutionEnv();
    const backendURL = executionEnvData.backendURL;
    const getOrganizationURL = endpointUrls.getAttorney + param;
    const getOrganizationEndpoint = backendURL + getOrganizationURL;
    return this.http.get(getOrganizationEndpoint);
  }

  addAttorney(data): Observable<any> {
    const executionEnvData = this.authService.getBackendURLAndExecutionEnv();
    const backendURL = executionEnvData.backendURL;
    const getOrganizationURL = endpointUrls.AddAttorney;
    const getOrganizationEndpoint = backendURL + getOrganizationURL;
    return this.http.post(getOrganizationEndpoint, data);
  }

  editAttorney(data): Observable<any> {
    const executionEnvData = this.authService.getBackendURLAndExecutionEnv();
    const backendURL = executionEnvData.backendURL;
    const getOrganizationURL = endpointUrls.editAttorney;
    const getOrganizationEndpoint = backendURL + getOrganizationURL;
    return this.http.post(getOrganizationEndpoint, data);
  }
 
  deleteAttorney(id): Observable<any> {
    const executionEnvData = this.authService.getBackendURLAndExecutionEnv();
    const backendURL = executionEnvData.backendURL;
    const deleteAttorneyURL = endpointUrls.deleteAttorney + id;
    const deleteAttorneyEndpoint = backendURL + deleteAttorneyURL;
    return this.http.post(deleteAttorneyEndpoint, null);
  }
}
